<section class="flex flex-col w-full max-w-5xl mx-auto px-2 sm:px-3 gap-4 sm:gap-6 min-w-0 overflow-x-hidden">
  <header class="min-w-0">
    <h1 class="text-xl sm:text-2xl font-bold text-gray-800">Utilisateurs</h1>
    <p class="text-sm text-gray-600 mt-1">
      Liste des comptes inscrits, triés du plus récent au plus ancien.
    </p>
  </header>

  <div class="bg-white rounded-md shadow-xl border border-gray-100 overflow-hidden min-h-[220px] min-w-0">
    @if (loading()) {
      <div class="flex flex-col items-center justify-center gap-3 py-16 px-4">
        <span class="material-symbols-outlined text-secondary text-5xl animate-spin">progress_activity</span>
        <p class="text-sm text-gray-600">Chargement des utilisateurs…</p>
      </div>
    } @else if (users().length === 0) {
      <div class="px-4 py-10 text-center text-sm text-gray-500">Aucun utilisateur.</div>
    } @else {
      <ul class="md:hidden divide-y divide-gray-100">
        @for (u of users(); track u.uuid) {
          <li class="p-4 flex flex-col gap-2">
            <div class="flex items-start justify-between gap-2">
              <div class="min-w-0">
                <p class="text-sm font-semibold text-gray-900 break-words">{{ u.fullName }}</p>
                <p class="text-xs text-gray-500 break-all">{{ u.email }}</p>
              </div>
              @if (u.admin) {
                <span class="shrink-0 rounded-md bg-red-100 text-red-700 border border-red-200 px-2 py-0.5 text-[10px] font-semibold uppercase">Admin</span>
              }
            </div>
            <div class="flex flex-wrap gap-x-3 gap-y-1 text-xs text-gray-500">
              <span>{{ roleLabel(u.role) }}</span>
              <span>{{ u.emailVerified ? 'E-mail vérifié' : 'E-mail non vérifié' }}</span>
              <span>{{ u.registeredAt | date: 'dd/MM/yyyy HH:mm' }}</span>
            </div>
          </li>
        }
      </ul>

      <div class="hidden md:block overflow-x-auto">
        <table class="w-full text-sm">
          <thead>
            <tr class="bg-gray-50 text-left text-gray-600">
              <th class="px-4 py-3 font-medium">Nom</th>
              <th class="px-4 py-3 font-medium">E-mail</th>
              <th class="px-4 py-3 font-medium">Rôle</th>
              <th class="px-4 py-3 font-medium">Admin</th>
              <th class="px-4 py-3 font-medium">Vérifié</th>
              <th class="px-4 py-3 font-medium">Inscription</th>
            </tr>
          </thead>
          <tbody>
            @for (u of users(); track u.uuid) {
              <tr class="border-t border-gray-100 hover:bg-gray-50">
                <td class="px-4 py-3 font-medium text-gray-900">{{ u.fullName }}</td>
                <td class="px-4 py-3 text-gray-600">{{ u.email }}</td>
                <td class="px-4 py-3 text-gray-600">{{ roleLabel(u.role) }}</td>
                <td class="px-4 py-3">
                  @if (u.admin) {
                    <span class="rounded-md bg-red-100 text-red-700 border border-red-200 px-2 py-0.5 text-[10px] font-semibold uppercase">Oui</span>
                  } @else {
                    <span class="text-gray-400">Non</span>
                  }
                </td>
                <td class="px-4 py-3 text-gray-600">{{ u.emailVerified ? 'Oui' : 'Non' }}</td>
                <td class="px-4 py-3 text-gray-600 whitespace-nowrap">{{ u.registeredAt | date: 'dd/MM/yyyy HH:mm' }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</section>
